<div class="calsoft-vertical-navigation-content"
	>
#navigationContent>
<calsoft-general  [pageTitle]="PageTitle"></calsoft-general>
</div>